import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPasswordStyles as styles } from './styles';

import { check_email, insert_password, reset_password_email_sent } from '../../constants/messages';

import { Box, Typography, TextField, Button, makeStyles, DialogTitle, Dialog, DialogContent } from '@material-ui/core';

import ChangePasswordForm from '../common/ChangePasswordForm';

import api from '../../api/authApi';
import { clearBookingInfo } from '../../redux/actions/book-appointment';
import { toastr } from 'react-redux-toastr';

function ForgotPassword() {
    const { token } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [newPassword, setNewPassword] = useState({ value: '', showPassword: false });
    const [confirmNewPassword, setConfirmNewPassword] = useState({ value: '', showPassword: false });
    const organisation = useSelector(state => state.auth.organisation);
    const [displayInfo, setDisplayInfo] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [email, setEmail] = useState('');
    const classes = makeStyles(styles)();

    const title = isResetPassword ? insert_password : check_email(organisation.name);

    useEffect(() => {
        const url = window.location.pathname.split('/');
        if (!url.includes('reset-password')) return;
        setIsResetPassword(true);

        const resetPassword = async () => {
            try {
                const response = await api.getUserEmailFromToken(token);
                setEmail(response.email);
            } catch (err) {
                console.error(err);
            }
        };

        resetPassword();
    }, [token]);

    async function handleSubmit(e) {
        e.preventDefault();

        if (isResetPassword) {
            if (newPassword.value !== confirmNewPassword.value) {
                setDisplayInfo(true);
                return;
            }

            try {
                const { newToken } = await api.changePassword({ token, newPassword: newPassword.value });
                localStorage.setItem('token', newToken);
                dispatch(clearBookingInfo());

                setIsDialogOpen(true);
            } catch (err) {
                console.error(err);
                toastr.error('Failed to change password');
            }

            return;
        }

        if (!email.length) {
            toastr.error('You must enter an email address.');
            return;
        }

        try {
            const response = await api.forgotPassword(email.toLowerCase());
            if (response.error) throw new Error(response.message);
            setIsDialogOpen(true);
        } catch (e) {
            setDisplayInfo(true);
            console.error(e);
        }
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                <Box className={classes.logoBox}>
                    <DialogTitle className={classes.title}>Reset Password Request</DialogTitle>
                </Box>
                <Typography style={{ textAlign: 'justify' }}>{title}</Typography>

                <form onSubmit={handleSubmit} autoComplete="on">
                    {isResetPassword ? (
                        <ChangePasswordForm
                            newPassword={newPassword}
                            confirmNewPassword={confirmNewPassword}
                            onClickNewPassword={() =>
                                setNewPassword({ ...newPassword, showPassword: !newPassword.showPassword })
                            }
                            onClickConfirmNewPassword={() =>
                                setConfirmNewPassword({
                                    ...confirmNewPassword,
                                    showPassword: !confirmNewPassword.showPassword
                                })
                            }
                            onChangeNewPassword={event => setNewPassword({ ...newPassword, value: event.target.value })}
                            onChangeConfirmNewPassword={event =>
                                setConfirmNewPassword({ ...confirmNewPassword, value: event.target.value })
                            }
                        />
                    ) : (
                        <TextField
                            className={classes.margin1RemTop}
                            fullWidth
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                            variant="outlined"
                            label="Email"
                            type="email"
                            required
                            name="email"
                            autoComplete="username"
                        />
                    )}

                    {isResetPassword && (
                        <>
                            <input type="email" name="username" value={email} autoComplete="username" readOnly hidden />
                            <input
                                type="password"
                                name="password"
                                value={newPassword.value}
                                autoComplete="current-password"
                                readOnly
                                hidden
                            />
                        </>
                    )}

                    {displayInfo && (
                        <Typography className={`${classes.info} ${isResetPassword ? classes.warning : ''}`}>
                            {isResetPassword ? 'Passwords do not match' : reset_password_email_sent}
                        </Typography>
                    )}

                    <Button type="submit" className={[classes.margin1RemTop, classes.button]}>
                        Reset password
                    </Button>
                </form>
            </Box>

            <Dialog open={isDialogOpen} className={classes.container}>
                <DialogTitle className={classes.title}>
                    {isResetPassword ? '' : 'Your link has been emailed'}
                </DialogTitle>
                <DialogContent>
                    {isResetPassword
                        ? 'Your new password has been created.'
                        : 'If you do not receive it, check that you have entered the correct email. Please also check your junk folder.'}
                    <Box display="flex" justifyContent="center" className={classes.buttonsContainer}>
                        <Button
                            className={[classes.button]}
                            onClick={() => {
                                setIsDialogOpen(false);
                                history.push('/');
                            }}
                        >
                            Continue
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default ForgotPassword;
